import React from 'react';

import styled from 'styled-components';

import { Listing } from 'api/ListingController/getListing';
import { ListingListItem } from 'components/List';

import theme from '../theme';

export interface ListingResultProps {
  item: Listing;
  onClick: () => void;
}

const ListingResult: React.FC<ListingResultProps> = ({ item, onClick }) => (
    <Container onMouseDown={ev => ev.preventDefault()} onClick={onClick}>
      <ListingListItem listing={item} />
    </Container>
  );

export default ListingResult;

const Container = styled.div`
  &:hover {
    background-color: ${theme.gray5};
    cursor: pointer;
  }
`;
